(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

jQuery(document).ready(function ($) {
  /* Required for animations to work */
  var continuousElements = document.getElementsByClassName('seg-animation');
  for (var i = 0; i < continuousElements.length; i++) {
    new Waypoint({
      element: continuousElements[i],
      handler: function handler() {
        switch (true) {
          case $(this.element).hasClass('slide-from-right'):
            $(this.element).addClass('sa-engage');
            break;
          case $(this.element).hasClass('slide-from-left'):
            $(this.element).addClass('sa-engage');
            break;
          case $(this.element).hasClass('slide-up'):
            $(this.element).addClass('sa-engage');
            break;
          case $(this.element).hasClass('fade-in'):
            $(this.element).addClass('sa-engage');
            break;
        }
      },
      offset: '95%'
    });
  }
});

},{}],2:[function(require,module,exports){
"use strict";

require("./base.js");
/*import './vendor/modernizr.js';*/

/*
* Copyright (c) 2020 Matthew Swetnam
*/
jQuery(document).ready(function ($) {
  console.log("SEG");
});

},{"./base.js":1}]},{},[2]);
